import styled from 'styled-components';

import { IconPin, IconPinFilled } from '@u21/tabler-icons';
import { U21Button } from 'app/shared/u21-ui/components';
import { getDOMProps } from 'app/shared/utils/react';
import { HTMLProps } from 'react';

interface Props extends Omit<HTMLProps<HTMLButtonElement>, 'onClick'> {
  onPinChange?: () => void;
  pinned: boolean;
}

export const FilterPinButton = (props: Props) => {
  const { onPinChange, pinned, ...rest } = props;
  if (!onPinChange) {
    return null;
  }
  return (
    <U21Button
      aria-label="pin"
      icon={pinned ? <StyledIconPinFilled /> : <IconPin />}
      onClick={(e) => {
        e.stopPropagation();
        onPinChange();
      }}
      {...getDOMProps(rest)}
    />
  );
};

const StyledIconPinFilled = styled(IconPinFilled)`
  color: ${(props) => props.theme.palette.primary.main};
`;
